<template>
    <div
        ref="pinned"
        class="absolute top-0 left-0 flex flex-col justify-center mt-12 lg:mt-24 m-auto md:ml-16"
    >

        <div v-if="$parent.sound" class="">
            <button
                @click="$parent.toggle()"
                style="margin-left: -0.125rem;"
                class="relative inline-block w-8 h-8 p-2 rounded-full mb-4 transform lg:hover:scale-125 transition duration-300 ease-in-out"
                :class="$parent.playing ? 'bg-aqua-500 ' : 'bg-blue-500'"
            >
                <svg
                    style="margin-left: -0.0625rem;"
                    class="w-full text-white fill-current transition-opacity duration-300 ease-in-out"
                    :class="$parent.playing ? 'opacity-0' : 'opacity-100'"
                    viewBox="0 0 49 49"
                >
                    <path clip-rule="evenodd" d="m17.0844 9.11866c0-2.36377 2.6065-3.79902 4.604-2.53516l24.498 15.5004c1.8613 1.1776 1.8613 3.8926 0 5.0703l-24.498 15.5003c-1.9975 1.2639-4.604-.1714-4.604-2.5351z" fill-rule="evenodd"/>
                </svg>

                <div
                    class="absolute inset-0 flex justify-between w-full h-full px-3 py-2 transition-opacity duration-300 ease-in-out"
                    :class="$parent.playing ? 'opacity-100' : 'opacity-0'"
                >
                    <div class="w-2px h-full bg-white"></div>
                    <div class="w-2px h-full bg-white"></div>
                </div>
            </button>
        </div>

        <div
            class="inline-block bg-white md:bg-transparent shadow-md md:shadow-none rounded-full md:rounded-none p-1 md:p-0 transition-opacity duration-300 ease-in-out-quad"
            :class="mobileShow ? 'opacity-100' : 'opacity-0 md:opacity-100'"
        >
            <ul class="flex flex-row md:flex-col justify-center -m-1">
                <share action="facebook" :url="facebookShare" tooltip="Share on Facebook"></share>
                <share action="twitter" :url="twitterShare" tooltip="Share on Twitter"></share>
                <share action="copylink" :url="fullUrl" tooltip="Copy Link to Clipboard"></share>
            </ul>
        </div>
    </div>
</template>

<script>
import debounce from 'lodash/debounce';
import share from './social-share-item.vue';

export default {
    components: {
        share
    },

    props: ['title', 'rootUrl'],

    data() {
        return {
            controller: new ScrollMagic.Controller(),
            scene: null,
            offset: 0,
            breakPoint: 768,
            scrolled: 0
        };
    },

    computed: {
        fullUrl() {
            return `${this.rootUrl}${window.location.pathname}`;
        },

        facebookShare() {
            return `https://www.facebook.com/sharer.php?u=${this.fullUrl}`;
        },

        twitterShare() {
            return `https://twitter.com/share?url=${this.fullUrl}&amp;text=${this.title}&amp;hashtags=tnaqua`;
        },

        mobileShow() {
            if (this.scrolled > window.innerHeight) {
                return true;
            } else {
                return false;
            }
        }
    },

    mounted() {
        window.addEventListener('resize', this.restart);

        this.debounceScroll = debounce(this.onScroll, 100);
        window.addEventListener('scroll', this.debounceScroll);

        this.scrollSetup();
    },

    destroyed() {
        window.removeEventListener('scroll', this.debounceScroll);
        window.removeEventListener('resize', this.restart);
    },

    methods: {
        scrollSetup() {
            if (window.innerWidth >= this.breakPoint) {
                this.offset = window.innerHeight / 2 - 64;
            } else {
                this.offset = -window.innerHeight / 2 + 96;
            }

            this.initScrolling();
        },

        initScrolling() {
            this.scene = new ScrollMagic.Scene({
                triggerElement: this.$parent.$refs.article,
                offset: this.offset,
                duration: this.$parent.$refs.article.clientHeight
            })
                .setPin(this.$refs.pinned)
                .addTo(this.controller);
        },

        onScroll(e) {
            this.scrolled = window.top.scrollY;
        },

        restart() {
            this.scene.destroy(true);
            this.scene = null;
            this.scrollSetup();
        }
    }
};
</script>
